import { useEffect } from "react";
import { useSearchParams, useNavigate, NavigateFunction } from "react-router-dom";
import { fetchApplicationStatusAndRedirectIfNotExpectedState } from "../../applicationPages/applicationStatusHelpers";
import { ApplicationStatusModel } from "../../serverGeneratedTypings/applicationStatusModel";
import style from "./style.module.scss";

export type CommonStatusPageProps = {
    navigateToCorrectStepFunc : (application: ApplicationStatusModel, applicantId: string, navigate: NavigateFunction) => void;
}

type ApplicationStatusPageProps = {
    correctStateFunc: (applicationStatus: ApplicationStatusModel) => boolean;
    navigateToCorrectStepFunc : (application: ApplicationStatusModel, applicantId: string, navigate: NavigateFunction) => void;
};

type ApplicationStatusPagePropsCombined = React.PropsWithChildren & ApplicationStatusPageProps;

export const ApplicationStatusPage = ({children, correctStateFunc, navigateToCorrectStepFunc}: ApplicationStatusPagePropsCombined): JSX.Element => {
    const [searchParams] = useSearchParams();

    const applicationId = searchParams.get("applicationId");  
    const applicantId = searchParams.get("applicantId");  

    const navigate = useNavigate();
 
    useEffect(() => {
    
        fetchApplicationStatusAndRedirectIfNotExpectedState(applicationId, applicantId || "", correctStateFunc, 
            () => undefined, navigate, navigateToCorrectStepFunc);

    },  [applicationId, navigate, applicantId, correctStateFunc, navigateToCorrectStepFunc]); 

   return (<>
            <div className={style.wrapper}>
                {children}
            </div>
        </>
    );
}